import { ApiService } from '@services/api.service';
import { TableDataApiParams } from '@services/practices.service';
import { Observable, throwError } from 'rxjs';
import { TablePaginationRespModel } from '@/models/table-pagination-resp.model';
import { RentalReservationModel } from '@/models/rentals/rental-reservation.model';
import { catchError, map, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { LoggerService } from '@services/logger.service';

export interface ReservationConflictFilters {
  rentalPracticeId: number;
  excludeId?: number;
}

@Injectable({
  providedIn: 'root',
})
export class RentalReservationService extends ApiService {
  getReservationsByPractice(
    filters: ReservationConflictFilters,
  ): Observable<RentalReservationModel[]> {
    const params: TableDataApiParams = {
      page: 1,
      size: 100,
      rentalPracticeId: filters.rentalPracticeId,
    };

    return this.http
      .get<TablePaginationRespModel<RentalReservationModel>>(
        this.baseUrl + '/rental-reservation/page',
        { params: { ...params } as any },
      )
      .pipe(
        map((resp) => resp?.content ?? []),
        map((rows) =>
          filters.excludeId != null ? rows.filter((r) => r.id !== filters.excludeId) : rows,
        ),
      );
  }

  getBrands(): Observable<any> {
    return this.http.get(this.baseUrl + `/rental-reservation/brands`).pipe(
      map((response: any) => {
        LoggerService.log(response, 'getBrands');
        return response;
      }),
    );
  }

  getDataForTable(
    params?: TableDataApiParams,
  ): Observable<TablePaginationRespModel<RentalReservationModel>> {
    return new Observable<TablePaginationRespModel<RentalReservationModel>>((observer) => {
      this.http
        .get<TablePaginationRespModel<RentalReservationModel>>(
          this.baseUrl + '/rental-reservation/page',
          { params: { ...params } },
        )
        .pipe(
          tap((response) => {
            observer.next(response);
            observer.complete();
          }),
          catchError((error) => {
            observer.error(error);

            return throwError(error);
          }),
        )
        .subscribe();
    });
  }

  saveReservation(reservation: RentalReservationModel) {
    return this.http
      .post<RentalReservationModel>(this.baseUrl + '/rental-reservation/save', reservation)
      .pipe(
        map((response: any) => {
          LoggerService.log(response, 'saveReservation');

          return response;
        }),
      );
  }

  deleteReservation(rentalReservationId: number) {
    return this.http.delete(this.baseUrl + `/rental-reservation/${rentalReservationId}`).pipe(
      map((response: any) => {
        LoggerService.log(response, 'deleteReservation');

        this.triggerUpdate();
        this.toastr.success('Prenotazione cancellata correttamente');

        return response;
      }),
      catchError((error) => {
        this.toastr.error('Errore durante la cancellazione della prenotazione');
        return throwError(error);
      }),
    );
  }

  linkToPractice(reservationId: number, practiceId: number): Observable<RentalReservationModel> {
    return this.http
      .post<RentalReservationModel>(
        this.baseUrl + `/rental-reservation/${reservationId}/link-practice/${practiceId}`,
        {},
      )
      .pipe(
        map((response: any) => {
          LoggerService.log(response, 'linkToPractice');
          return response;
        }),
      );
  }
}
